import { VisEdge } from '../types';

const getRelatedVisNodes = (id: string, edges: VisEdge[]) => {
  const related = edges
    .filter((e) => e.from === id || e.to === id)
    .flatMap((e) => [e.to, e.from])
    .filter((id, i, arr) => arr.indexOf(id) === i);
  return related;
};

export default getRelatedVisNodes;
